import createReactComponent from '../createReactComponent';
var Watch = createReactComponent('Watch', [['circle', {
  cx: '12',
  cy: '12',
  r: '7',
  key: 'fim9np'
}], ['polyline', {
  points: '12 9 12 12 13.5 13.5',
  key: '1lg4lc'
}], ['path', {
  d: 'M16.51 17.35l-.35 3.83a2 2 0 01-2 1.82H9.83a2 2 0 01-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 019.83 1h4.35a2 2 0 012 1.82l.35 3.83',
  key: 'qhk6zo'
}]]);
export default Watch;